<template>
	<div class="dashboard">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Stock Sync Checker</h1>
		<div class="content-wrapper">
			<b-field label="Select Shop (required)">
				<b-autocomplete
					v-model="shopsSuggestions"
					:data="filteredShops"
					:open-on-focus="true"
					placeholder="Shop"
					field="name"
					@select="option => (selectedShop = option)"
					class="shopAutoComplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</b-field>

			<div class="datepickerWrapper">
				<b-field label="Date">
					<b-datepicker :date-formatter="dateFormatter" placeholder="Click to select..." v-model="startingDate" icon="calendar-today">
						<button class="button is-primary" @click="startingDate = new Date()">
							<b-icon icon="calendar-today"></b-icon>
							<span>Today</span>
						</button>

						<button class="button is-danger" @click="startingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>

				<b-field label="Ending Date">
					<b-datepicker
						:date-formatter="dateFormatter"
						placeholder="Click to select..."
						v-model="endingDate"
						icon="calendar-today"
						:min-date="minDate"
					>
						<button class="button is-danger" @click="endingDate = null">
							<b-icon icon="close"></b-icon>
							<span>Clear</span>
						</button></b-datepicker
					>
				</b-field>
			</div>

			<div class="filter-button-wrapper">
				<div class="big-button" @click="submit()">EXPORT</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Dashboard',
	data: () => ({
		limit: 20,
		isLoading: false,
		startingDate: null,
		endingDate: null,
		minDate: null,
		shops: [], // For list of shops from API
		shopsSuggestions: '', // For dropdown selection
		selectedShop: null, // Selected shop
		orders: []
	}),

	watch: {
		startingDate: function(data) {
			if (data !== null) {
				this.minDate = data
				// this.maxDate = new Date(data.getFullYear(), data.getMonth(), data.getDate() + 30)

				this.endingDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getShops()
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	methods: {
		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops({})

			this.shops = apiGetShops.data.list
		},

		submit: async function() {
			if (this.selectedShop == null || this.startingDate == null) {
				this.$swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'All the fields are required'
				})

				return
			}

			this.histories = []
			this.isLoading = true

			var data = {}
			const createdAt = {}

			if (this.startingDate !== null) {
				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')
			}

			if (this.startingDate !== null) {
				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')
			}

			// For getting total value of sales
			data = {
				limit: this.limit,
				skip: 0,
				time: {
					createdAt
				}
			}

			if (this.selectedShop && this.selectedShop._id) {
				data.shop = this.selectedShop._id
			}

			// const result = await this.$api.shopProductHistory({ data })
			const result = await this.$api.getOrders({ data })
			if (result && result.data.count > 0) {
				result.data.list.map(item => {
					this.orders.push(item._id)
				})
			}

			if (result.data.total > this.limit) {
				let totalLoop = Math.ceil(result.data.total / this.limit)

				if (totalLoop > 1) {
					var i

					for (i = 1; i < totalLoop; i++) {
						const skip = i * this.limit

						data.skip = skip

						const result = await this.$api.getOrders({ data })

						if (result && result.data.count > 0) {
							result.data.list.map(item => {
								this.orders.push(item._id)
							})
						}
					}
				}
			}

			if (this.orders.length > 0) {
				this.getOrderItems()
			} else {
				this.isLoading = false
			}
		},

		// Loop all the orders and get items
		getOrderItems: async function() {
			let items = []

			for (const order of this.orders) {
				const data = {
					id: order
				}

				const orderDetail = await this.$api.getOrderDetails({ data })

				if (orderDetail && orderDetail.data.pay_status == 1) {
					// console.log(orderDetail.data)
					// Loop all the items from the order
					for (const item of orderDetail.data.items) {
						//For Quantity

						if (!items[item.product._id]) {
							items[item.product._id] = {
								product: item.product,
								id: item.product._id,
								qty: item.qty
							}
						} else {
							const qty = items[item.product._id].qty + item.qty
							items[item.product._id].qty = qty
						}

						if (item.product.bd_code == 'BES-02176') {
							console.log(items[item.product._id])
						}

						// For FOC. Loop all the product promo
						if (item.promotions && item.promotions.length > 0) {
							const promotions = item.promotions

							for (const promotion of promotions) {
								if (promotion.type == 'discount_product_buy_and_get_foc_from_list') {
									console.log('product FOC')

									const products = promotion.options.products

									for (const product of products) {
										if (!items[product]) {
											items[product] = {
												product: product,
												id: product,
												qty: 1
											}
										} else {
											const qty = items[product].qty + 1
											items[product].qty = qty
										}
									}
								}
							}
						}
					}

					// For Order FOC
					if (orderDetail.data.promotions && orderDetail.data.promotions.length > 0) {
						const promotions = orderDetail.data.promotions

						for (const promotion of promotions) {
							if (
								promotion.type == 'discount_order_foc__from_product_list' ||
								promotion.type == 'discount_order_give__some_qty__from_product_list__by_total_product_price_of_brand'
							) {
								console.log('Order FOC')

								const products = promotion.options.products

								for (const product of products) {
									if (!items[product]) {
										items[product] = {
											product: product,
											id: product,
											qty: 1
										}
									} else {
										const qty = items[product].qty + 1
										items[product].qty = qty
									}
								}
							}
						}
					}
				}
			}

			if (items) {
				this.checkHistory(items)
			} else {
				this.isLoading = false
			}
		},

		checkHistory: async function(items) {
			for (const item in items) {
				const product = items[item]

				console.log('Total sold', product.product.bd_code, product.qty)

				const data = {
					limit: 1,
					shop_product: {
						product: product.id,
						shop: this.selectedShop._id
					},
					time: {},
					sort: {
						createdAt: 'desc'
					}
				}

				// get previous history for quantity
				const preCreatedAt = {}

				preCreatedAt['$lte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')

				data.time.createdAt = preCreatedAt

				const previousHistory = await this.$api.shopProductHistory({ data })
				const lastStock = previousHistory.data.list[0].shop_product.stock

				console.log('Previous data ', lastStock)

				const createdAt = {}

				createdAt['$gte'] = this.$moment(this.startingDate)
					.set({ hour: 0 })
					.format('x')

				createdAt['$lte'] = this.$moment(this.endingDate)
					.set({ hour: 24 })
					.format('x')

				data.limit = 0
				data.time.createdAt = createdAt
				data.sort.createdAt = 'asc'

				// Get history
				const histories = await this.$api.shopProductHistory({ data })

				let total = 0
				let previousStock = 0
				let firstRound = true

				if (histories && histories.data.list.length > 0) {
					for (const history of histories.data.list) {
						const stock = history.shop_product.stock

						console.log(stock)

						if (firstRound) {
							// To make sure no stock adjustment are made
							if (lastStock > stock) {
								total = lastStock - stock
							}
						} else {
							if (previousStock > stock) {
								total += previousStock - stock
							}
						}
						firstRound = false
						previousStock = stock
					}
				}

				console.log('Total', total)

				console.log('*************************************************************************')
			}

			this.isLoading = false
		},

		// For calender format
		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		}
	}
}
</script>

<style scoped>
@import '../styles/GeneralStyles.css';
</style>
